import { TextAreaElement } from "components/input/textArea/textAreaElement";
import { Tooltip } from "components/components/tooltip/tooltip";


const template = document.createElement("template");
template.innerHTML = `
      <style>
      s6-textarea-compact {
        border: 1px solid #ccc;
        border-radius: 4px;
        transition: box-shadow 200ms;
      }
      .c-textareacompact {
          padding: 0;
          box-sizing: border-box;
          min-width: 20px;
          height: 2.6rem;
          display:flex;
          padding: 0;
          //height:calc(100% - 2px);
      }

      .c-textareacompact i {
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        -webkit-font-smoothing: antialiased;
        display: inline-block;
        font-style: normal;
        font-variant: normal;
        text-rendering: auto;
        line-height: 1;
        padding: 0.25rem 0  0.25rem  0.5rem;
        user-select: none;
        padding: 6px 12px 6px 6px;;
      }

      .c-textareacompact i::before {
        content: '...';
        font-family: 'Font Awesome 5 Free';
        color: #0066A1;
      }
      .c-textareacompact .preview {
          flex-grow:1;
          overflow: hidden;
          white-space: nowrap;
          height: 2.6rem;
      }
      </style>
      <div class="c-textareacompact">
      <div class="preview"></div>
      <i class="chevron"></i>
      </div>
    `;

export class TextAreaCompactElement extends HTMLElement {
    private overlay;
    private chevron;
    private previewElement: HTMLDivElement;
    private _data: string;
    private _valid: boolean;
    private visited: boolean = false;

    constructor() {
        super();
        // this._shadowRoot = this.attachShadow({ mode: "open" });
        this.appendChild(template.content.cloneNode(true));

        this.chevron = this.querySelector(".chevron");
        this.previewElement = this.querySelector(".preview");
        this.chevron.addEventListener("click", () => {
            if (this.overlay == null) {
                this.overlay = document.createElement("s6-overlay");
                this.overlay.setAttribute("nested-tree", "yes");
                let ms = document.createElement("s6-text-area") as TextAreaElement;
                ms.data = this.data;
                this.overlay.appendChild(ms);
                ms.setAttribute("rows", this.getAttribute("rows"));
                ms.setAttribute("inputwidth", this.getAttribute("inputwidth"));
                ms.setAttribute("maxlength", this.getAttribute("maxlength"));
                this.append(this.overlay);
                ms.focus();
                ms.addEventListener("change", () => {
                    this.data = ms.data;
                    this.dispatchEvent(new Event("change"));
                });
            } else {
                this.removeOverlay();
            }
        });
        this.addEventListener("blur", () => {
        });
        this.addEventListener("focus", () => {
            this.visited = true;
            this.focus();
        });
        if (!this.hasAttribute("tabindex")) {
            this.tabIndex = 0;
        }

        this.addEventListener("keyup", this.keyup);
        Tooltip.bindElement(this);
    }

    private keyup = (e) => {
        if (e.key === " " && !this.hasAttribute("readonly") && this.overlay == null) {
            this.chevron.dispatchEvent(new Event("click"));
        } else if (e.key === "Escape") {
            this.removeOverlay();
        }
    }

    private removeOverlay() {
        this.focus();
        if (this.overlay != null) {
            this.overlay.remove();
            this.overlay = null;
        }
    }

    private connectedCallback() {
        this.upgradeProperties();
    }

    private upgradeProperties() {
        for (const key in this) {
            if (this.hasOwnProperty(key)) {
                let value = this[key];
                delete this[key];
                this[key] = value;
            }
        }
    }

    public set data(data: string) {
        this._data = data;
        if (data == null) {
            this.previewElement.innerText = "";
        } else {
            const oneLineData = data.replace(/\n/g, "");
            this.previewElement.innerText = oneLineData;
        }
    }

    public get data(): string {
        return this._data;
    }

    public focus() {
        super.focus();
    }

    public set readOnly(ro: boolean) {
        if (ro) {
            this.setAttribute("readonly", "true");
            this.chevron.remove();
        } else {
            this.removeAttribute("readonly");
            if (!this.chevron.isConnected) {
            }
        }
    }

    public set valid(valid: boolean) {
        this._valid = valid ?? true;
        if (this._valid) {
            this.classList.remove("has-error");
            this.classList.remove("is-pending");
            this.removeAttribute("data-tip");
        } else {
            if (this.visited) {
                this.classList.add("has-error");
                this.classList.remove("is-pending");
            } else {
                this.classList.add("is-pending");
            }
        }
    }

    public set validationMessage(message) {
        if (message != null) {
            this.setAttribute("data-tip", message);
        }
    }
}

export function initTextAreaCompactWebComponent() {
    window.customElements.define("s6-textarea-compact", TextAreaCompactElement);
}
